<template>
  <div>
    <b-table
      hover
      small
      fixed
      :fields="sypplyFields"
      :items="sypplyItems"
      :per-page="perPage"
      id="my-table"
      :current-page="currentPage"
    >
      <template v-slot:cell(quantity)="data">
        {{ data.item.quantity }}
      </template>

      <template v-slot:cell(actions)="data">
        <a
          title="Eliminar"
          target="_blank"
          @click.prevent="deleteSupplyDetail(data.item)"
          href="#"
          class="fa fa-lg fa-trash text-danger pull-right"
        ></a>
        <a
          title="Editar"
          target="_blank"
          @click.prevent="editSupplyDetail(data.item)"
          href="#"
          class="fa fa-lg fa-pencil text-primary pull-right"
        >
        </a
        >&nbsp;
        <!-- <a
          target="_blank"
          href="#"
          @click.prevent="printContent(data.item)"
          class="fa fa-lg fa-print text-primary pull-right"
        >
        </a
        >&nbsp; -->
      </template>
    </b-table>
    <div class="mt-3">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        align="center"
      ></b-pagination>
    </div>

    <b-modal
      v-model="editSupply"
      title="Editar detalle de materiales"
      @ok="submitEditDetailed"
    >
      <form ref="form">
        <b-row>
          <b-col>
            <b-form-group label="Material">
              <v-select
                :options="supplies"
                label="text"
                v-model="form.supply"
                class="style-chooser"
                disabled
              >
              </v-select>
            </b-form-group>
            <b-form-group label="Cantidad">
              <b-form-input
                type="text"
                id="quantity"
                v-model="form.quantity"
                placeholder="ej. 1234"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<script>
import miniToastr from "mini-toastr";
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

export default {
  name: "DetailedSupplyTable",
  props: ["sypplyItems", "sypplyFields", "waybillID"],
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      editSupply: false,
      form: {
        id: "",
        supply: "",
        quantity: ""
      }
    };
  },

  mounted() {},
  filter: {},
  components: {},
  created() {
    this.getSupplies();
  },
  computed: {
    rows() {
      return this.sypplyItems.length;
    }
  },
  methods: {
    getSupplies() {
      this.supplies = [{ id: "", name: "Cargando..." }];
      this.$axios
        .get("/api/supplies/supply/select_input/")
        .then((res) => {
          const data = res.data;
          const supplies = [];
          for (let key in data) {
            const company = data[key];
            supplies.push(company);
          }
          this.supplies = supplies;
        })
        .catch((error) => console.log(error));
    },
    onComplete() {},
    loadWaybill(a) {},
    loadDetails(a) {
      //   this.$axios
      //     .get("api/supplies/waybill/" + a + "/waybill_detail/")
      //     .then((res) => {
      //       this.items = res.data;
      //     })
      //     .catch((error) => console.log(error));
    },
    getCompleteWaybill() {
      this.$axios
        .get(
          "/api/supplies/waybill/" + this.waybillData.id + "/waybill_report/"
        )
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
      return true;
    },
    deleteSupplyDetail(a) {
      this.$axios
        .delete("/api/supplies/waybill-supply/delete_stock/", {
          data: {
            stock_id: a.id
          }
        })
        .then((res) => {
          miniToastr.success("Detalle de guía eliminado con éxito", "");
          this.$emit("loadSupplyDetails");
        })
        .catch((error) => {
          miniToastr.error(error.response.data, "");
          console.log(error);
        });
    },
    editSupplyDetail(data) {
      this.form.id = data.id;
      this.form.supply = data.supply.name;
      this.form.quantity = data.quantity;
      this.editSupply = true;
    },
    submitEditDetailed(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler

      if (this.form.quantity > 0 && this.form.quantity != "") {
        this.$axios({
          method: "PUT",
          url: "/api/supplies/waybill-supply/update_stock/",
          data: {
            stock_id: this.form.id,
            quantity: this.form.quantity
          }
        })
          .then((res) => {
            if (res.data.result == 1) {
              this.editSupply = false;
              this.form.id = "";
              this.form.supply = "";
              this.form.quantity = "";

              miniToastr.success("Materiales actualizado con éxito", "");
              this.$emit("loadSupplyDetails");
            }
          })
          .catch((error) => {
            console.log("%o", error);
          });
      } else {
        miniToastr.info("Cantidad no puede 0 y es requerido", "");
      }
    },
    printContent(data) {
      data["waybill_data"] = this.waybillData;
      this.$refs.printContent.modalShown = true;
      this.$refs.printContent.contentPrint = data;
    },
    submitWaybill() {
      this.$refs.waybillForm.submit();
      if (this.formStepVal1 === true) {
        parent = this;
        return this.saveWaybill();
      } else {
        return false;
      }
    },
    saveWaybill: async () => {
      const formData = {
        number: parent.waybillData.number,
        waybill_date: parent.waybillData.waybill_date,
        waybill_type: parent.waybill_type,
        // arrival_datetime: parent.waybillData.arrival_datetime,
        internal_note: parent.waybillData.internal_note,
        note: parent.waybillData.note,
        license_plate: parent.waybillData.license_plate,
        truck_driver: parent.waybillData.truck_driver,
        company: parent.waybillData.company,
        client_customer: parent.waybillData.client_customer,
        recipient_company: parent.waybillData.recipient
      };
      if (parent.edit_waybill === false) {
        try {
          const res = await parent.$axios
            .post("/api/v1/waybill/", formData)
            .then((res) => {
              miniToastr.success("Guía creada con éxito", "");
              parent.waybillData.id = res.data.id;
              parent.edit_waybill = true;
              parent.validated = true;
              // parent.getContents(res.data.id);
            })
            .catch(function (error) {
              parent.$swal.fire(
                error.response.data.non_field_errors[0],
                "",
                "warning"
              );
              parent.validated = false;
            });
        } catch (err) {
          console.log("erroor" + err);
        }
      } else {
        try {
          const res = await parent.$axios
            .put("/api/v1/waybill/" + parent.waybillData.id + "/", formData)
            .then((res) => {
              miniToastr.info("Guía actualizada con éxito", "");
              parent.waybillData.id = res.data.id;
              parent.validated = true;
              // parent.getContents(res.data.id)
            })
            .catch(function (error) {
              parent.$swal.fire(
                error.response.data.non_field_errors[0],
                "",
                "warning"
              );
              parent.validated = false;
            });
        } catch (err) {
          console.error("erroor" + err);
        }
      }

      return parent.validated;
    }
  }
};
</script>

<style scoped></style>
